import {RouteMeta} from "@/types";

export const getMetaLabel = (metaKey: string, metaValue: string | number, metaStructure: RouteMeta[]) => {
    const _metaStructure = metaStructure.find(m => m.key == metaKey)
    if (!_metaStructure) return null;
    return _metaStructure?.options.find(o => o.key == metaValue)?.label ?? null;
}